import {Vue, Component, Prop, PropSync, Provide, ProvideReactive, Watch} from 'vue-property-decorator';
import { Map, Marker, polyline } from "leaflet";
import Trip from "../../models/trip.model";
declare let L: any;

@Component<MapComponent>({
  components: ({})
})
export default class MapComponent extends Vue {
  @Prop() private itineraryProps!: any;
  @Prop() private trips!: any;

  private darkIcon = L.icon({
    iconUrl: process.env.VUE_APP_LEAFMAP_DARK_ICON_URL,
    iconSize: [45, 45],
    iconAnchor: [21, 25],
    popupAnchor: [1, -10]
  });

  private orangeIcon = L.icon({
    iconUrl: process.env.VUE_APP_LEAFMAP_ORANGE_ICON_URL,
    iconSize: [25, 25],
    iconAnchor: [21, 20],
    popupAnchor: [-8, -10]
  });

  private map: Map;
  private itinerary = this.itineraryProps;
  private markers: any = [{}];
  private polylines: any;
  private latlngs: any = [];
  private airplanes: any = [];
  private curvedPath: any;

  public constructor() {
    super();
    this.$nextTick(() => {
      this.initMap();
    });
  }

  public mounted() {
    return true;
  }

  public created() {
    return true;
  }

  public destroyed() {
    return true;
  }

  public updated() {
    return true;
  }

  @Watch("trips", {deep: true, immediate: true})
  onTripsUpdated(newVal: any, oldVal: any){
    console.log(this.trips);
    this.$nextTick(() => {
      this.redefinePinsArray(newVal);
    });
  }

  private initMap() {
    let startLatLng: L.LatLngExpression;
    if (this.trips.length > 0 && this.itinerary.length > 0 && this.itinerary[0].name) {
      startLatLng = [this.trips[0].lat, this.trips[0].lng];
    } else {
      startLatLng = [51.959, 10.623];
    }
    this.map = L.map("mapContainer", {
      maxBounds: [[-180, 190], [180, -170]]
    }).setView(startLatLng, 3);

    this.map.options.minZoom = 1;
    this.map.options.maxZoom = 18;
    L.mapboxGL({
      accessToken: process.env.VUE_APP_LEAFMAP_APIKEY,
      style: "map-style/tiles.json",
      //style: "https://api.maptiler.com/maps/basic/style.json?key=GnqjLco7OmfDlWAlcbPv",
      tileLayer: {
        continuousWorld: false,
        noWrap: true
      }
    }).addTo(this.map);

    this.markers.splice(0, 1);
    this.redefinePinsArray(this.trips);
  }

  private redefinePinsArray(trips: Array<Trip>) {
    for (let i = 0; i < this.markers.length; i++) {
      this.map.removeLayer(this.markers[i]);
    }
    this.markers = [];
    this.trips = trips;

    for (let i = 0; i < this.trips.length; i++) {
      let trip = this.trips[i];
      if (trip.fromCity || trip.toCity) {
        if (i === 0) {
          if (trip.lat && trip.fromCity) {
            let markerFrom = L.marker([trip.lat, trip.lng], {
              icon: this.orangeIcon
            })
              .bindPopup(trip.fromCityObject.name)
              .on("click", this.clickOnMarker)
              .addTo(this.map);
            this.markers.push(markerFrom);
          }

          if (trip.fromCity) this.map.setView([trip.lat, trip.lng], 3);

          if (trip.toLat && trip.toCity) {
            let markerTo = L.marker([trip.toLat, trip.toLng], {
              icon: this.darkIcon
            })
              .bindPopup(trip.toCityObject.name)
              .on("click", this.clickOnMarker)
              .addTo(this.map);
            this.markers.push(markerTo);
          }

          this.drawRoutes(trip);
          if (trip.toCity) this.map.setView([trip.toLat, trip.toLng], 3);
        } else {
          if (trip.lat && trip.fromCity) {
            let markerFrom = L.marker([trip.lat, trip.lng], {
              icon: this.darkIcon
            })
              .bindPopup(trip.fromCityObject.name)
              .on("click", this.clickOnMarker)
              .addTo(this.map);
            this.markers.push(markerFrom);
          }

          if (trip.fromCity) this.map.setView([trip.lat, trip.lng], 3);

          if (trip.toLat && trip.toCity) {
            if (
              trip.id === this.trips[this.trips.length - 1].id &&
              this.trips[0].fromCity === trip.toCity
            ) {
              let markerTo = L.marker([trip.toLat, trip.toLng], {
                icon: this.orangeIcon
              })
                .bindPopup(trip.toCityObject.name)
                .on("click", this.clickOnMarker)
                .addTo(this.map);
              this.markers.push(markerTo);
            } else {
              let markerTo = L.marker([trip.toLat, trip.toLng], {
                icon: this.darkIcon
              })
                .bindPopup(trip.toCityObject.name)
                .on("click", this.clickOnMarker)
                .addTo(this.map);
              this.markers.push(markerTo);
            }
          }
          this.drawRoutes(trip);
          if (trip.toCity) this.map.setView([trip.toLat, trip.toLng], 3);
        }
      }
    }

    const bounds = new L.LatLngBounds();
    for(let i = 0; i < this.markers.length; i++){
      bounds.extend(this.markers[i].getLatLng());
    }
    // this.map.flyToBounds(bounds);

    const that = this;
    setTimeout(function(){
      that.map.invalidateSize();
      that.map.fitBounds(bounds);
      // that.map.panInsideBounds(bounds);
    }, 800);

    // this.map.locate({setView: true});
    // const fg = L.featureGroup(this.markers).addTo(this.map);
    // this.map.setZoom(10);
    // this.map.fitBounds(fg.getBounds());
  }

  private clickOnMarker(e: any) {
    this.map.setView(e.target.getLatLng(), 6);
  }

  private drawRoutes(city: any) {
    for (let i = 0; i < this.latlngs.length; i++) {
      this.map.removeLayer(this.latlngs[i]);
      this.map.removeLayer(this.airplanes[i]);
    }

    for (let i = 0; i < this.markers.length - 1; i++) {
      if (
        i % 2 === 0 &&
        this.markers[i]._latlng.lat !== this.markers[i + 1]._latlng.lat
      ) {
        this.curveRouteCreation(
          this.markers[i]._latlng.lat,
          this.markers[i + 1]._latlng.lat,
          this.markers[i]._latlng.lng,
          this.markers[i + 1]._latlng.lng
        );
      }
    }
    // this.map.setView(this.latlngs.getBounds().getCenter(), 1);
    // const bounds = L.latLngBounds(this.markers);
    // this.map.fitBounds(bounds);
    // const grp = new L.featureGroup(this.markers);
    // this.map.fitBounds(grp.getBounds());
  }

  private curveRouteCreation(
    latitudeA: number,
    latitudeB: number,
    longtitudeA: number,
    longtitudeB: number
  ) {
    let latlng1 = [latitudeA, longtitudeA],
      latlng2 = [latitudeB, longtitudeB];

    let offsetX = latlng2[1] - latlng1[1],
      offsetY = latlng2[0] - latlng1[0];

    let r = Math.sqrt(Math.pow(offsetX, 2) + Math.pow(offsetY, 2)),
      theta = Math.atan2(offsetY, offsetX);

    let thetaOffset = 3.14 / 50;

    let r2 = r / 2 / Math.cos(thetaOffset),
      theta2 = theta + thetaOffset;

    let midpointX = r2 * Math.cos(theta2) + latlng1[1],
      midpointY = r2 * Math.sin(theta2) + latlng1[0];

    let midpointLatLng = [midpointY, midpointX];

    let pathOptions: any = {
      color: "#444",
      weight: 2,
      lineCap: "square",
      dashArray: "5, 5"
    };

    let xToY = Math.sqrt(
      Math.pow(latitudeB - latitudeA, 2) +
      Math.pow(longtitudeB - longtitudeA, 2)
    );

    let X = latitudeB + (xToY / -6) * Math.cos(50);
    let Y = longtitudeB + (xToY / -6) * Math.sin(-230);

    let X2 = latitudeA + (xToY / -6) * Math.cos(-230);
    let Y2 = longtitudeA + (xToY / -6) * Math.sin(-230);

    let x = [latitudeA, X2, X, latitudeB];
    let y = [longtitudeA, Y2, Y, longtitudeB];

    let polyline = L.polyline(this.bezierCurve(x, y), pathOptions).addTo(
      this.map
    );

    let decorator = L.polylineDecorator(polyline, {
      patterns: [
        {
          offset: 100,
          repeat: 0,
          symbol: L.Symbol.arrowHead({ pixelSize: 40 })
        }
      ]
    }).addTo(this.map);

    let arrowOffset = 0;

    setInterval(function() {
      decorator.setPatterns([
        {
          offset: arrowOffset + "%",
          repeat: 0,
          symbol: L.Symbol.arrowHead({
            pixelSize: 15,
            polygon: true,
            pathOptions: {
              fillOpacity: 0.9,
              color: "#FF8F00",
              stroke: true,
              opacity: 1
            }
          })
        }
      ]);
      if (++arrowOffset > 100) arrowOffset = 0;
    }, 30);

    this.latlngs.push(polyline);
    this.airplanes.push(decorator);
  }

  private bezierCurve(x: any, y: any) {
    let xu = 0,
      yu = 0;
    let i = 0;
    let points = [];
    for (let u = 0; u <= 1; u += 0.1) {
      let point;
      xu =
        Math.pow(1 - u, 3) * x[0] +
        3 * u * Math.pow(1 - u, 2) * x[1] +
        3 * Math.pow(u, 2) * (1 - u) * x[2] +
        Math.pow(u, 3) * x[3];
      yu =
        Math.pow(1 - u, 3) * y[0] +
        3 * u * Math.pow(1 - u, 2) * y[1] +
        3 * Math.pow(u, 2) * (1 - u) * y[2] +
        Math.pow(u, 3) * y[3];
      point = [xu, yu];
      points.push(point);
    }
    points.splice(points.length - 2, 1);
    points.splice(1, 1);
    return points;
  }
}
